import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const WhyChooseUsPage = lazy(() => import('../pages/why-choose-us/page'));
const SituationsPage = lazy(() => import('../pages/situations/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />
  },
  {
    path: '/why-choose-us',
    element: <WhyChooseUsPage />
  },
  {
    path: '/situations',
    element: <SituationsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/reviews',
    element: <ReviewsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;